module.exports = __webpack_public_path__ + "img/1581150780.f5924efe.jpg";